const getArgumentRegex = (key, values) => {
  const keyParts = key.split('.');

  const regexString = keyParts.reduce((acc, curr, idx, arr) => {
    let currentKey = '';
    let newKey;

    arr.forEach((keyPart, keyPartIdx) => {
      if (keyPartIdx <= idx) {
        currentKey += keyPart;
      }
    });

    if (values[currentKey]?.type === 'arrayMap') {
      newKey = curr.replace('[]', '(\\[\\])');
    } else {
      newKey = curr.replace('[]', '\\[(\\d+)\\]');
    }

    if (acc === '') {
      return newKey;
    }

    return `${acc}\\.${newKey}`;
  }, '');

  return new RegExp(`^${regexString}`);
};

export default getArgumentRegex;
